import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({ selector: "[OnlyLowerCaseCharacters]" })
export class OnlyLowerCaseCharactersDirective {
  constructor(private hostElement: ElementRef) {}

  @HostListener("input") onInput() {
    const value = this.hostElement.nativeElement.value;
    const charValue = value.replace(/[^a-z_]/g, "");

    if (value !== charValue) {
      this.hostElement.nativeElement.value = charValue;
    }
  }
}
